import { FeatureFlag, FeatureFlagValue } from './FeatureFlag';
import { usePrerenderUserFeatures } from './usePrerenderUser';

export { FeatureFlag };
export type { FeatureFlagValue };

function useFeatureFlag(requiredFeatureFlags: FeatureFlagValue[]): boolean {
  const features = usePrerenderUserFeatures();

  for (const requiredFeatureFlag of requiredFeatureFlags) {
    if (!features.includes(requiredFeatureFlag)) {
      return false;
    }
  }

  return true;
}

export default useFeatureFlag;
